import { render, staticRenderFns } from "./AssignmentTable.vue?vue&type=template&id=108af8ad&"
import script from "./AssignmentTable.vue?vue&type=script&lang=js&"
export * from "./AssignmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports